import { useBreakpoints } from "@vueuse/core";

export const useScreenBreakpoints = () => {
  return useBreakpoints({
    mobile: 0, // optional
    tablet: 640,
    laptop: 1024,
    desktop: 1280,
  });
};
